import React, { Component } from "react";
import SSO from "../../sso";
import config from "../../sso/config";
import { validateRedirectUrl } from "../../utilities/redirectValidation";

/**
 * JWTCallback Component
 * Handles JWT token callback from OIDC authentication
 * Backend sets tokens in HttpOnly cookies - no URL parsing needed
 */
class JWTCallback extends Component {
  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectParam = urlParams.get('redirect');
    const redirectTo = validateRedirectUrl(redirectParam);
    
    localStorage.setItem(config.fetch_details_param, false);
    
    SSO.fetchDetails(false)
      .then(() => {
        window.location.href = redirectTo;
      })
      .catch((err) => {
        console.error('Failed to fetch user details:', err);
        window.location.href = '/preLogin';
      });
  }

  render() {
    return null;
  }
}

export default JWTCallback;
